import React from 'react';
import { HStack, PinInput, PinInputField } from '@chakra-ui/react';

interface VerificationCodeInputProps {
  onComplete: (code: string) => void;
  disabled?: boolean;
  error?: boolean;
}

const VerificationCodeInput: React.FC<VerificationCodeInputProps> = ({
  onComplete,
  disabled = false,
  error = false,
}) => {
  return (
    <HStack justify="center" spacing={2} wrap="nowrap">
      <PinInput
        otp
        type="number"
        isDisabled={disabled}
        onComplete={(val) => onComplete(val)}
        errorBorderColor={error ? 'red.500' : undefined}
        manageFocus
      >
        {[0, 1, 2, 3, 4, 5].map((i) => (
          <PinInputField
            key={i}
            width="2rem"
            height="2.5rem"
            fontSize="lg"
          />
        ))}
      </PinInput>
    </HStack>
  );
};

export default VerificationCodeInput;
